(function () {
  window.theme = window.theme || {};
  var $doc = window.jQuery ? jQuery(document) : null;

  /* ---------------- Modal shell ---------------- */
  function ensureModal() {
    if (document.getElementById('qb-modal')) return;
    var wrap = document.createElement('div');
    wrap.id = 'qb-modal';
    wrap.className = 'qb-modal';
    wrap.setAttribute('aria-hidden', 'true');
    wrap.innerHTML = [
      '<div class="qb-modal__overlay" data-qb-close></div>',
      '<div class="qb-modal__dialog" role="dialog" aria-modal="true" aria-label="Quick buy">',
        '<div class="qb-modal__header">',
          '<div class="qb-modal__close" aria-label="Close" data-qb-close>',
            '<svg role="img" width="35" height="35" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="needsclick  kl-private-reset-css-Xuajs1"><title id="title-Close-dialog">Close dialog</title><circle cx="10" cy="10" r="9.5" fill="rgba(180,187,195,0)" stroke="rgba(255,255,255,0)" style="cursor: pointer;"></circle><path d="M6 6L14 14M6 14L14 6L6 14Z" stroke="#5c83a5" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" style="cursor: pointer;"></path></svg>',
          '</div>',
        '</div>',
        '<div class="qb-modal__body"></div>',
      '</div>'
    ].join('');
    document.body.appendChild(wrap);

    // Close interactions
    wrap.addEventListener('click', function (e) {
      if (e.target.closest('[data-qb-close]')) closeModal();
      if (e.target.closest('.qb-modal__dialog')) e.stopPropagation();
    });

    // ESC closes
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && wrap.getAttribute('aria-hidden') === 'false') closeModal();
    });
  }

  function openModal() {
    ensureModal();
    var modal = document.getElementById('qb-modal');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('qb-modal-open');
     setTimeout(() => {
       $ = hulkapps_jQuery;
        window.getHulk()

    }, 2000);
  }

  function closeModal() {
    var modal = document.getElementById('qb-modal');
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('qb-modal-open');
    var bodyEl = modal.querySelector('.qb-modal__body');
    if ($doc) {
      $doc.find('.qb-modal__body .product-form').trigger('unload-product-form');
    }
    bodyEl.classList.remove('qb-is-loading');
    bodyEl.innerHTML = '';
  }

  /* ---------------- Loading state & spinner ---------------- */
  function setModalLoading(isLoading) {
    var modal = document.getElementById('qb-modal');
    if (!modal) return;
    var bodyEl = modal.querySelector('.qb-modal__body');
    if (!bodyEl) return;

    if (isLoading) {
      bodyEl.classList.add('qb-is-loading');
      bodyEl.innerHTML =
        '<div class="qb-loader" role="status" aria-label="Loading">' +
          '<svg class="qb-loader__svg" viewBox="0 0 50 50" width="48" height="48" aria-hidden="true">' +
            '<circle class="qb-loader__ring" cx="25" cy="25" r="20" fill="none" stroke-width="4"></circle>' +
          '</svg>' +
        '</div>';
    } else {
      bodyEl.classList.remove('qb-is-loading');
      // content will be injected by fillModalWithQuickbuy
    }
  }

  /* ---------------- Extract & normalize fragment ---------------- */
  function extractQB(htmlText) {
    var tmp = document.createElement('div');
    tmp.innerHTML = htmlText;

    var qb = tmp.querySelector('.quickbuy-content');
    if (qb) return qb;

    var fallback =
      tmp.querySelector('.product-main, .product__main, [data-product-main], .product-section, .Product__Wrapper') ||
      tmp.querySelector('main, #MainContent, .page-container');

    return fallback || tmp;
  }

  function normalizeQBFragment(qbRoot, productUrl) {
    if (!qbRoot) return;

    qbRoot.querySelectorAll('.more').forEach(a => a.setAttribute('href', productUrl));

    var t = qbRoot.querySelector('.detail .title');
    if (t && !t.querySelector('a')) {
      var a = document.createElement('a');
      a.href = productUrl;
      a.innerHTML = t.innerHTML;
      t.innerHTML = '';
      t.appendChild(a);
    }

    qbRoot.querySelectorAll('.show-gallery').forEach(a => {
      a.classList.remove('show-gallery');
      a.setAttribute('href', productUrl);
    });
    qbRoot.querySelectorAll('.not-in-quickbuy').forEach(el => el.remove());
    qbRoot.querySelectorAll('.only-in-quickbuy').forEach(el => el.classList.remove('only-in-quickbuy'));
    qbRoot.querySelectorAll('.sticky-content-container').forEach(el => el.classList.remove('sticky-content-container'));
    qbRoot.querySelectorAll('.store-availability-container').forEach(el => el.remove());
    qbRoot.querySelectorAll('[data-enable-history-state="true"]').forEach(el => el.setAttribute('data-enable-history-state', 'false'));
    qbRoot.querySelectorAll('.gallery .thumbnails').forEach(el => el.classList.remove('mobile-only'));

    [
      'gallery--layout-carousel-beside',
      'gallery--layout-columns-1',
      'gallery--layout-columns-2',
      'gallery--layout-collage-1',
      'gallery--layout-collage-2'
    ].forEach(cl => {
      qbRoot.querySelectorAll('.' + cl).forEach(el => {
        el.classList.remove(cl);
        el.classList.add('gallery--layout-carousel-under');
      });
    });
  }

  /* ---------------- Insert content + re-init theme ---------------- */
  function fillModalWithQuickbuy(productUrl, htmlText) {
    var modal = document.getElementById('qb-modal');
    var bodyEl = modal.querySelector('.qb-modal__body');

    var frag = extractQB(htmlText);
    normalizeQBFragment(frag, productUrl);

    setModalLoading(false);
    bodyEl.innerHTML = '';
    bodyEl.appendChild(frag);

    if (window.theme?.initProductGallery) theme.initProductGallery(bodyEl);

    if ($doc) {
      $doc.find('.qb-modal__body .product-form')
        .trigger('load-product-form')
        .on('variantChanged', function () { /* optional */ });

      /* Might not be needed */
      var $container = $doc.find('.qb-modal__body');
      $container.closest('[data-components]').each(function () {
        var comps = (this.getAttribute('data-components') || '').split(',');
        comps.forEach(c => { if (c) $doc.trigger('cc:component:load', [c, bodyEl]); });
      });
      $doc.trigger('cc:component:load', ['custom-select', bodyEl]);
    }

    if (window.theme?.initAnimateOnScroll) theme.initAnimateOnScroll();
  }

  /* ---------------- Public opener ---------------- */
  theme.openQuickbuyModal = function (productUrl) {
    if (!productUrl) return;
    openModal();
    setModalLoading(true);

    // Abort previous request
    if (theme.currentQuickbuyRequest?.abort) {
      try { theme.currentQuickbuyRequest.abort(); } catch {}
    }

    if (window.jQuery) {
      theme.currentQuickbuyRequest = jQuery.get(productUrl, function (response) {
        fillModalWithQuickbuy(productUrl, response);
      }).always(function () {
        theme.currentQuickbuyRequest = null;
      });
    } else {
      fetch(productUrl, { credentials: 'same-origin' })
        .then(r => r.text())
        .then(html => fillModalWithQuickbuy(productUrl, html))
        .catch(() => {
          var bodyEl = document.getElementById('qb-modal')?.querySelector('.qb-modal__body');
          if (bodyEl) {
            setModalLoading(false);
            bodyEl.textContent = 'Something went wrong loading Quick Buy.';
          }
        });
    }
  };

  /* ---------------- Bind button clicks ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quickbuy-toggle');
    if (!btn) return;

    var productUrl = btn.getAttribute('data-quickbuy-href') || btn.getAttribute('href') || '';
    if (!productUrl) return;

    if (window.innerWidth > 767) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation?.();
      theme.openQuickbuyModal(productUrl);
    } else {
      if (btn.getAttribute('href') === '#' && productUrl) {
        e.preventDefault();
        window.location.assign(productUrl);
      }
    }
  }, true);
})();

document.addEventListener('click', function (e) {
  const btn = e.target.closest('#qb-modal a[data-quantity]');
  if (!btn) return;

  const wrapper = btn.closest('.quantity-wrapper');
  if (!wrapper) return;

  const input = wrapper.querySelector('input[name="quantity"]');
  if (!input) return;

  e.preventDefault();

  const min = parseInt(input.getAttribute('min') || '1', 10);
  const step = parseInt(input.getAttribute('step') || '1', 10);
  const current = parseInt(input.value || '1', 10);

  let newVal = current;
  if (btn.dataset.quantity === 'up') {
    newVal = current + step;
  } else if (btn.dataset.quantity === 'down') {
    newVal = Math.max(min, current - step);
  }

  input.value = newVal;

  input.dispatchEvent(new Event('input', { bubbles: true }));
  input.dispatchEvent(new Event('change', { bubbles: true }));
}, true);

